(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-all"] && !Shopify.designMode) return;
  try {
    
// Filter By Tags
   
//   document.addEventListener("DOMContentLoaded", function () {
//     let filtersButton = document.querySelectorAll(".tag-filter");
//     let idofProductsWrapper = document.getElementById("collection-page-filters");
//     let filterProducts = idofProductsWrapper.querySelectorAll(".grid__item");
//     if (filtersButton) {
//         filtersButton.forEach(function (filters) {
//             filters.addEventListener("click", function (e) {
//               filters.classList.remove("active")
          

//                 this.classList.add("active");
            
//                 let tag = filters.dataset.tag;
//                 console.log(tag)
//                 if (filterProducts) {
//                     filterProducts.forEach(function (product) {
//                         console.log(product.getAttribute('data-collections'));
//                         let productTags = product.getAttribute('data-collections').split(",");
//                     //   console.log(productTags);
//                         if (productTags.includes(tag)) {
//                             product.classList.add("shown");
//                           product.classList.remove("hidden");
//                         }
//                         else {
//                             product.classList.remove("shown");
//                              product.classList.add("hidden");
//                         }
                        
//                     })
//                 }
//             })
//         })
//     }
// })
  document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".tag-filter");
  const productsWrapper = document.getElementById("collection-page-filters");
  const productCards = productsWrapper?.querySelectorAll(".grid__item");



  filterButtons.forEach(function (button) {
    button.addEventListener("click", function () {
     
      filterButtons.forEach(btn => btn.classList.remove("active"));
      
      
      this.classList.add("active");

      const selectedTag = this.dataset.tag;
      console.log("Selected tag:", selectedTag);

      productCards.forEach(function (product) {
        const productTags = product.getAttribute("data-collections")?.split(",") || [];
        const isMatch = productTags.includes(selectedTag);

        if (isMatch) {
          product.classList.add("shown");
          product.classList.remove("hidden");
        } else {
          product.classList.remove("shown");
          product.classList.add("hidden");
        }
      });
    });
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
